export class LoginModel{
    username:string;
    password:string;
}

export class MenuModel{
    nombre: string;
    url: string;
}